import React from 'react';
import Grid from '../MuiGrid/Grid';
import { Text, Link, Colors } from '@origin-digital/style-guide';
import { makeStyles } from '@material-ui/core/styles';
import { ChevronRightIcon } from '@origin-digital/icon';

interface IChatWithUs {
  icon: string;
  headline: string;
  description: string;
  buttonText: string;
  buttonLink: string;
}

const ChatWithUs: React.FunctionComponent<IChatWithUs> = ({
  icon,
  headline,
  description,
  buttonText,
  buttonLink
}) => {
  const useStyles = makeStyles({
    description: {
      marginBottom: '10%'
    },
    link: {
      display: 'flex',
      flexDirection: 'row',
      marginTop: '10%',
      color: Colors.RED,
      textDecoration: 'none'
    }
  });

  const classes = useStyles();
  return (
    <Grid
      container
      justify="center"
      alignContent="center"
      direction="row"
      className="chat-with-us-grid-ie"
    >
      <Grid item xs={9} sm={9} md={6} lg={6} xl={6}>
        <div
          dangerouslySetInnerHTML={{
            __html: icon
          }}
        />
      </Grid>
      <Grid item container direction="column" justify="center" xs={9} sm={9} md={6} lg={6}>
        <Grid item>
          <h2>{headline}</h2>
          <Text>{description}</Text>

          <Link className={classes.link} href={buttonLink}>
            <Text color="red">{buttonText}</Text>
            <ChevronRightIcon color="red" />
          </Link>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ChatWithUs;
